module.exports = __webpack_public_path__ + "img/arc.d2b949a7.png";